import { defineStore } from 'pinia';

const useStatusCompStore = defineStore('statusComp', {
  state: () => ({
    isShowStatusComp: true,
    runningList: [],
    taskList: [],
  }),
});

export default useStatusCompStore;
